<router-outlet />
<ngx-spinner
  type="ball-spin-clockwise"
  size="medium"
  name="core-spinner"
  template="<img src='../assets/images/placeholders/spinner.svg' alt='terabase loading' />"
/>
